module.exports = new __parcel__URL__("gold_plasma_cannon_skin.423dcdec.png").toString();